import { render, staticRenderFns } from "./PsiraReg.vue?vue&type=template&id=8b036514&"
import script from "./PsiraReg.vue?vue&type=script&lang=ts&"
export * from "./PsiraReg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports